import React, { useState, useEffect, useReducer } from 'react';
import jwtDecode from 'jwt-decode'
import Encrypt from 'jsencrypt/bin/jsencrypt.min.js'

import StudentContext from './../context/student-context';
import StudentReducer from './../reducers/student-reducer';
import IdleTimeOutModal from './shared/modals/IdleTimeOutModal';
import AppRouter from '../routers/AppRouter';
import Loading from './../components/shared/Loading'
import { getStudentAndAuthentication, verifyJti, ResetJti, getServerKey,refreshToken } from '../actions/security-actions';

import { DecryptRSA } from '../utils/services/authentication/RSAService';
import { setCodeSession, setAuthKeySession, setStudentSelectClusterSession, setStudentNumberSession, setRewardPointsSession, getCodeSession, setStudentConsentSession, getStudentNumberFromSession } from '../utils/helpers/others/SessionHelper';
import { PublicServerKey, StudentProfile, Claims } from '../utils/services/cache/ClientCache'

if (getCodeSession()) {
    if ((jwtDecode(getCodeSession()).exp * 1000 + 50 * 60 * 1000) < new Date().getTime()) {
        ResetJti(getStudentNumberFromSession(), Claims.getJti());
        localStorage.clear();
        window.location.href = `${process.env.LOGOUT_URL}`;
    }
}

const StudentApp = () => {
    const [loading, setLoading] = useState(true);
    const [studentContext, dispatchStudent] = useReducer(StudentReducer);

    useEffect(() => {
        initAuth();
        const interval = setInterval(async () => {
            let tokenResponse = await refreshToken(Claims.getGivenName());
            if (tokenResponse.status === "Success") {
                let newCode = jwtDecode(tokenResponse.data);
                Claims.setJti(newCode.jti);
                Claims.setToken(tokenResponse.data);
            }
        }, 2400000);
        return () => clearInterval(interval);
    }, []);

    const initAuth = async () => {
        if (PublicServerKey.getaesKey() ? false : true) {
            if (getCodeSession() ? false : true) {
                try {

                    const queryString = require('query-string');
                    const parsedHash = queryString.parse(location.hash);
                    setCodeSession(parsedHash.id_token);

                    let code = getCodeSession();

                    let decoded = jwtDecode(code);
                    Claims.setGivenName(decoded.given_name)
                    Claims.setJti(decoded.jti);
                    Claims.setToken(code);

                    let keySize = parseInt("1024");
                    let crypt = new Encrypt({ default_key_size: keySize });
                    crypt.getKey();

                    let response = await getServerKey(crypt.getPublicKey());
                    let key = DecryptRSA(crypt.getPrivateKey(), response.data.symmetricKey);
                    let iv = DecryptRSA(crypt.getPrivateKey(), response.data.symmetricIv);

                    PublicServerKey.setaesKey(key);
                    PublicServerKey.setaesIV(iv);

                }
                catch (e) {
                    console.error(e);
                }
            }
        }
        if (StudentProfile.getIsVerify() ? false : true) {
            
            if (Claims.getToken() ? true : false) {
                let verfication = await verifyJti(Claims.getJti(), Claims.getGivenName())
                if (verfication.data.symmetricKey === "Failed") {
                    localStorage.clear();
                    window.location.href = `${process.env.LOGIN_URL}`;
                }
                else {
                    const studentAndAuthentication = await getStudentAndAuthentication(Claims.getGivenName());
                    setStudentSelectClusterSession(studentAndAuthentication.selectCluster)
                    setStudentConsentSession(studentAndAuthentication.consented)
                    setAuthKeySession(studentAndAuthentication.authenticationKey);
                    setStudentNumberSession(studentAndAuthentication.studentNumber);
                    setRewardPointsSession(studentAndAuthentication.wallet);
                    StudentProfile.setSoundMute(true);
                    StudentProfile.setIsVerify("True");
                    dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: studentAndAuthentication.wallet });
                    dispatchStudent({ type: 'SET_DINOSAUR', dinosaur: { cluster: studentAndAuthentication.cluster, level: studentAndAuthentication.dinosaurLevel } });
                    dispatchStudent({ type: 'SET_GATED', gated: { gated: studentAndAuthentication.gated , loading: false}});
                }
            }
        }
        else {
            //console.log("Student Detail Loading Again!");
            const studentAndAuthentication = await getStudentAndAuthentication(Claims.getGivenName());
            if (studentAndAuthentication > 200) {
                localStorage.clear();
                window.location.href = `${process.env.LOGOUT_URL}`;
            }
            else {
                if (studentAndAuthentication) {
                    setStudentSelectClusterSession(studentAndAuthentication.selectCluster)
                    setStudentConsentSession(studentAndAuthentication.consented)
                    setAuthKeySession(studentAndAuthentication.authenticationKey);
                    setStudentNumberSession(studentAndAuthentication.studentNumber);
                    dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: studentAndAuthentication.wallet });
                    dispatchStudent({ type: 'SET_DINOSAUR', dinosaur: { cluster: studentAndAuthentication.cluster, level: studentAndAuthentication.dinosaurLevel } });
                    dispatchStudent({ type: 'SET_GATED', gated: { gated: studentAndAuthentication.gated , loading: false}});
                }else{
                    localStorage.clear();
                    window.location.href = `${process.env.LOGOUT_URL}`;
                }
            }
        }
        setLoading(false);
    };

    const loginWithRedirect = async () => {
        localStorage.clear();
        window.location.href = `${process.env.LOGIN_URL}`;
    };

    const logout = async () => {
        setLoading(true);
        ResetJti(getStudentNumberFromSession(), Claims.getJti());
        localStorage.clear();
        window.location.href = `${process.env.LOGOUT_URL}`;
    };

    const checkCodeSession = () =>{
        try{
            if(getCodeSession() == undefined || getCodeSession() == null) {
                return false;
            }
            return true;
        }catch (isError){
            return false;
        }
    }

    if (loading) return <Loading />;

    return (
        <StudentContext.Provider value={{ loginWithRedirect, logout, loading, studentContext, dispatchStudent }}>
            <IdleTimeOutModal />
            {checkCodeSession() ? <AppRouter/> : <></>}
            {/* <AppRouter/> */}
        </StudentContext.Provider>
    )
}

export { StudentApp as default }